// Purchase-card lists follow the Figma admin pricing page
// (file oNRDQ9HB6xKb4mQxD6wPNR, Settings - Billing). Desktop getPlanFeatures /
// settings_plans_feature_* can diverge — this portal has no Free card and a flattened Pro list.

// Not in dictation-only Growth or Enterprise.
export const NOTETAKER_FEATURES = [
  'Meeting Notetaker',
  'Identify speakers in meeting notes',
  'Ask questions about your meetings',
  'MCP to use notes in Claude, ChatGPT, and more',
]

// Growth and Enterprise force training off server-side, so their cards drop this line.
export const MODEL_TRAINING_OPT_OUT_FEATURE = 'Opt out of model training'

// No Free card exists in this portal, so every paid card leads with the base list instead of referencing it.
export const BASE_FEATURES = [
  'Unlimited dictations in 100+ languages, in any app on Mac, Windows, iOS, and Android',
  'Learns your names and jargon',
  ...NOTETAKER_FEATURES,
  'Connect to calendar and Slack',
  MODEL_TRAINING_OPT_OUT_FEATURE,
]

// The base list as dictation-only Growth and Enterprise get it.
export const ORG_BASE_FEATURES = BASE_FEATURES.filter(
  (feature) => feature !== MODEL_TRAINING_OPT_OUT_FEATURE && !NOTETAKER_FEATURES.includes(feature)
)

export const PRO_FEATURES = ['Centralized billing and user management', 'Shared dictionary and snippets']

export const ENTERPRISE_FEATURES = [
  'Enterprise security and admin controls',
  'SOC 2 Type II, ISO 27001, HIPAA-ready BAA',
  'Free seats for IT admins',
  'Audit logs, MDM, domain management',
  'SAML SSO, SCIM',
  'Dedicated support',
  'Volume discounts',
  'Advanced usage analytics',
  'Model training always off for your whole team',
]

// The teaser shown in UpgradePrompt. Named so the card list can be reordered without
// silently rewriting the banner.
export const UPGRADE_PROMPT_FEATURES = ENTERPRISE_FEATURES.slice(0, 3)

// Self-serve Growth card copy. Deliberately excludes SCIM, MDM, audit logs, and free
// IT admin seats — those moved to the sales-led Enterprise tier in the Growth/Enterprise split.
export const BUSINESS_FEATURES_INTRO = 'Get everything in Pro, plus:'
export const BUSINESS_FEATURES = [
  'Single sign-on (SSO) with SAML',
  'Org-wide model training and HIPAA enforcement with a signed BAA',
  'Multiple domains for one organization',
  'Admin tools for members, departments, and billing',
  'Priority support',
  'Pay by card, monthly or annual',
]

// Leads the Business feature list only while the bundle option is selected.
export const BUSINESS_BUNDLE_NOTETAKER_FEATURE = 'Unlimited Notetaker'

// Sales-led Enterprise card. Source: Figma admin pricing page, Card - Enterprise.
export const ENTERPRISE_SALES_FEATURES = [
  'Free IT admin seats',
  'Domain capture: require everyone on your domain to join',
  'User provisioning (SCIM)',
  'Audit logs and managed deployment (MDM)',
  'Block dictation in chosen apps',
  'Dedicated customer success manager',
  'Custom commercials and legal terms',
  'Invoicing and PO billing',
]

// Enterprise is sold dictation-only; this unticked note under both Enterprise cards says Notetaker can be added.
export const ENTERPRISE_NOTETAKER_NOTE = 'Notetaker is optional and can be added to your plan'
